export const LOGOUT = 'LOGOUT';

export const SET_TIMEOUT = 'SET_TIMEOUT';
export const SET_TIMEOUT_TIME = 'SET_TIMEOUT_TIME';
export const SET_KNOWLEDGE_ID = 'SET_KNOWLEDGE_ID';
export const SET_LINK = 'SET_LINK';
export const SET_IS_GENERATING = 'SET_IS_GENERATING';